angular.module("digitalLeasing.module").component("customerSearchTable", {
    templateUrl: "ng/components/digitalLeasing/plafondLoading/customerSearchTable/customerSearchTable.view.html",
    bindings: {
        model: "=", //financialModel
        richiestaConvenzionePlafond: "=",
        customerFound: "=",
        elementToAdd: "=" //BeneContratto
    },
    controllerAs: "customerSearchTableCtrl",
    controller: CustomerSearchTableCtrl
});

function CustomerSearchTableCtrl() {
    var self = this;

    self.$onInit = function () {};

    self.removeAdditionalRecipiant = function (customer, index) {
        if (self.richiestaConvenzionePlafond) {
            self.richiestaConvenzionePlafond.clientiDestinatari.splice(index, 1);
            self.customerFound = self.richiestaConvenzionePlafond.clientiDestinatari;
        } else {
            self.customerFound.forEach(function (element) {
                if (element === customer) {
                    self.customerFound.splice(element, 1);
                }
            });
            if (customer.firmatario) {
                self.elementToAdd.firmatari = self.customerFound;
            } else {
                self.elementToAdd.listaGaranti = self.customerFound;
            }

        }
    }
}